<template>
  <div class="page_card" v-loading="!is_ok">
    <el-card style="margin-right: 10px">
      <el-row :gutter="20" style="margin-bottom:10px">
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <el-button type="primary" plain @click="currentPlanBtn"
              >当前计划 {{ this.currentPlanNum }}</el-button
            >
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <el-button type="success" plain @click="pendApprovedPlanBtn"
              >待审批计划 {{ this.pendApprovedPlanNum }}</el-button
            >
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <el-button type="info" plain @click="approvedPlanBtn"
              >已审批计划 {{ this.approvedPlanNum }}</el-button
            >
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content bg-purple">
            <el-button type="warning" plain  @click="changePlanBtn"
              >变更计划 {{ this.changePlanNum }}</el-button
            >
          </div>
        </el-col>
        <el-col :span="5" style="margin-top: 8px" v-can="['btn:sales_audit']">
          <el-radio-group v-model="activeAudit" @change="switch_exm">
            <el-radio :label="true">销售审核</el-radio>
            <el-radio :label="false">自动审核</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-form :model="selectForm" ref="selectForm" inline>
        <el-form-item>
          <span style="font-weight:bold;">共{{planNumbers.length}}条</span>
        </el-form-item>
        <el-form-item label="企业名称或简称">
          <el-select style="width:200px"
            v-model="selectForm.comId"
            :multiple="false"
            filterable
            remote
            reserve-keyword
            placeholder="请输入企业名称或简称"
            :loading="is_select"
            @change="changeCom"
          >
            <el-option
              v-for="item in componys"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主车号">
          <el-input style="width:150px"
            v-model="selectForm.plateNumber"
            placeholder="请输入主车号"
          ></el-input>
        </el-form-item>

        <el-form-item label="驾驶员">
          <el-input style="width:150px"
            v-model="selectForm.driverName"
            placeholder="请输入驾驶员"
          ></el-input>
        </el-form-item>
        <el-form-item label="驾驶员电话">
          <el-input style="width:150px"
            v-model="selectForm.driverMobile"
            placeholder="请输入驾驶员电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="日期">
          <el-select v-model="selectForm.planDate" placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="今天" value="1"></el-option>
              <el-option label="明天" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="计划单状态">
            <el-select v-model="selectForm.newStatus" placeholder="请选择">
                <el-option v-for="(item,index) in statuType" :key="index" :label="item.lb" :value="item.vl"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-button
            plain
            type="primary"
            @click="selectSubmit()"
            :loading="is_post"
            >查 询</el-button
          >
          <el-button plain @click="resetSelect()" :loading="is_post"
            >重 置</el-button
          >
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="success"
            @click="goToAdd"
            v-can="['btn:add_plan']"
          >
            + 新增计划单</el-button
          >
          <el-button
            type="warning"
            plain
            @click="changePrice"
            v-show="activeName == 'first'"
            v-can="['btn:change_price']"
            ><svg-icon icon-class="price" /> 调价({{
              itemCheck.length
            }})</el-button
          >
          <el-button
            type="warning"
            plain
            icon="el-icon-download"
            v-can="['btn:add_plan']"
            @click="downloadExcel"
            >下载计划单模板</el-button
          >
          <el-button type="success" @click="batchApproval" v-can="['btn:project_approval']" :disabled="is_batch_pass"
            >批量审批</el-button
          >
          <el-button type="warning" @click="batchRejected" v-can="['btn:rejection_plan']" :disabled="is_batch_reject">批量驳回</el-button>
          <el-button type="warning" plain :icon="uploadBtnIcon" @click="clickUpload" v-can="['btn:add_plan']">导入计划单</el-button>
          <el-button type="warning" plain :icon="el-icon-download" @click="downloadCurrExcel" v-can="['btn:export_curr_order']">导出计划</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="调价" :visible.sync="is_price" width="25%">
        <el-form
          :model="priceForm"
          ref="priceForm"
          :rules="priceRules"
          label-width="120px"
          inline
        >
          <el-form-item
            label="调价(元/吨)"
            prop="realPrice"
            style="width: 100%"
          >
            <el-input
              v-model="priceForm.realPrice"
              placeholder="请输入调价价格"
            ></el-input>
          </el-form-item>

          <el-form-item style="width: 100%; text-align: center">
            <el-button
              plain
              type="primary"
              :loading="is_post"
              @click="submitPriceChange"
              >确认调价</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog title="添加定时调价" :visible.sync="is_time_price" width="50%">
          <el-button plain type="success" @click="timedPriceAdd">添加定时调价</el-button>
          <el-table border :data="discount_list">
              <el-table-column label="产品名称" >
                  <template slot-scope="scope">
                      <span>
                          {{scope.row.goodsName}}
                      </span>
                  </template>
              </el-table-column>
              <el-table-column label="调价金额">
                  <template slot-scope="scope">
                      <span class="danger_text">
                              {{scope.row.newPrice}}
                      </span>
                  </template>
              </el-table-column>
              <el-table-column label="调价时间" width="200">
                  <template slot-scope="scope">
                      {{scope.row.exeTime}}
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                      <el-button size="mini" type="danger" plain @click="delAllItem(scope.row,scope.$index)"><i class="el-icon-circle-close" />删除</el-button>
                  </template>
              </el-table-column>
            </el-table>
        </el-dialog>
      <el-dialog title="定时调价" :visible.sync="is_time_price_add" width="25%">
        <el-form
          :model="timePriceForm"
          ref="timePriceForm"
          :rules="timePriceRules"
          label-width="120px"
          inline
        >
          <el-form-item
            label="产品"
            prop="product"
            style="width: 100%">
              <el-select
                v-model="timePriceForm.product"
                placeholder="请选择"
                style="width: 108%">
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="item of goods_list"
                    :key="item.id">
                  </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="调价(元/吨)"
            prop="realPrice"
            style="width: 100%"
          >
            <el-input
              v-model="timePriceForm.realPrice"
              style="width: 116%"
              placeholder="请输入调价价格"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="调价时间"
            prop="time"
            style="width: 100%"
          >
           <el-date-picker
              v-model="timePriceForm.time"
              type="datetime"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择调价时间">
            </el-date-picker>
          </el-form-item>


          <el-form-item style="width: 100%; text-align: center">
            <el-button
              plain
              type="primary"
              :loading="is_post"
              @click="submitTimePriceChange"
              >确认调价</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-card>
    <div class="tabs">
       <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="销售计划" name="first" v-can="['btn:plan_index_sale']">
        <el-row v-loading="is_loading">
          <div v-if="dataList.length == 0">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
              "
            >
              <svg-icon style="font-size: 180px" icon-class="no_order" />
              <div style="color: #aaa">暂无计划单</div>
            </div>
          </div>
          <template v-else>
            <el-collapse
              v-model="activeNames"
              @change="handleChange"
              style="position: relative; margin-right: 10px"
            >
              <el-collapse-item
                v-for="(item, index) of dataList"
                :key="item.comID"
                :name="index"
              >
                <template slot="title">
                  <!-- <span style="display: inline-block;margin-right: 10px;font-size: 18px;" class="success_text">LNG</span> -->
                  <el-checkbox
                    style="margin-left: 10px"
                    @change="headCheckList(index)"
                    :indeterminate="item.isIndeterminate"
                    :model="item.checkAll"
                  ></el-checkbox>
                  <div
                    style="
                      width:280px;
                      overflow: hidden;
                      white-space: nowrap;
                      margin-left: 10px;
                      font-size: 15px;
                      font-weight: 500;
                    "
                  >
                    {{ item.companyName }}
                  </div>
                  <div
                    plain
                    style="
                      margin-left: 10px;
                      text-align: end;
                      width:110px;
                    "
                  >
                     {{ item.planNum }}
                  </div>
                  <div
                    style="
                      margin-left: 10px;
                      text-align: end;
                       width:110px;
                    "
                    plain
                  >
                    {{ item.realPlanNum }}
                  </div>
                  <div
                    style="
                      margin-left: 10px;
                      text-align: end;
                       width:110px;
                    "
                  >
                    {{ item.planWeight }}
                  </div>
                  <!-- <div
                    style="
                      margin-left: 10px;
                      text-align: end;
                       width:130px;
                    "
                  >
                    {{ item.realPlanWeight }}
                  </div> -->
                  <div
                    style="
                      margin-left: 10px;
                      text-align: end;
                       width:140px;
                    "
                  >
                    {{ parseNums(item.planPrice) }}
                  </div>
                  <!-- <div
                    style="
                      margin-left: 10px;
                       width:120px;
                    ">
                    {{ item.realPlanPrice }}
                  </div> -->
                  <div style="width:140px; text-align: end;">
                     {{ parseNums(item.balance)}}
                  </div>
                </template>
                <div class="content_table">
                  <!-- @row-click="checkItem" -->
                  <!-- @selection-change="handleSelectionChange" -->
                  <el-table
                    v-loading="is_loading"
                    style="width: 100%;"
                    :data="item.planOrders"
                    :row-class-name="tableRowClassName"
                    :row-style='changebg'
                    @select="selectHandle"
                    :header-cell-class-name="cellClass"
                    :header-cell-style='{background:"#1890ff",color:"#fff"}'
                  >
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                   <el-table-column
                      label=""
                      type="index"
                      align="center"
                      min-width="3%"
                    >
                      <template slot-scope="scope">
                      <i class="el-icon-star-on iconSize" :style="{color:scope.row.star==0 ? '' : 'green'}" @click="clickStar(scope.row)"></i>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="序号"
                      type="index"
                      align="center"
                      min-width="3%"
                      width="55"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="goodsName"
                      label="产品"
                      align="center"
                      min-width="7%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planDate"
                      label="计划日期"
                      align="center"
                      min-width="9%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planWeight"
                      align="center"
                      label="计划吨数"
                      min-width="7%"
                    >
                    </el-table-column>
                    <!-- <el-table-column
                      prop="deliverType"
                      label="计划类型"
                      align="center"
                      min-width="7%"
                    >
                      <template slot-scope="scope">
                        <div
                          class="primary_text"
                          v-if="scope.row.deliverType == 0"
                        >
                          本厂计划
                        </div>
                        <div
                          class="warning_text"
                          v-else-if="scope.row.deliverType == 1"
                        >
                          其他计划
                        </div>
                      </template>
                    </el-table-column> -->
                    <el-table-column
                      prop="plateNumber"
                      label="主车号"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="carriageNumber"
                      label="挂车号"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="driverName"
                      label="驾驶员"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="driverMobile"
                      label="联系电话"
                      align="center"
                      min-width="10%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="tradingPrice"
                      label="产品单价"
                      align="center"
                      min-width="7%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planAmount"
                      label="计划金额"
                      align="center"
                      min-width="7%"
                    >
                     <template slot-scope="scope">
                        <div>
                          {{ parseNums(scope.row.planAmount)}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="planAmount"
                      label="总金额（￥）"
                      align="center"
                      min-width="10%"
                    >
                      <template slot-scope="scope">
                        <div class="info_text">
                          {{ parseNums(scope.row.planAmount) + "元" }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="status"
                      label="状态"
                      align="center"
                      min-width="6%"
                    >
                      <template slot-scope="scope">
                        <div class="info_text">
                          {{ parseStatus(scope.row.status) }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="remark"
                      label="备注"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      align="center"
                      min-width="19%"
                    >
                      <template slot-scope="scope">
                        <div class="btn-box">
                          <el-button
                            size="mini"
                            type="info"
                            v-can="['btn:project_approval']"
                            style="padding:5px;margin-bottom: 5px;"
                            @click="exm_ok(scope.row)"
                            v-show="
                              scope.row.status == 0
                            "
                            >审核</el-button
                          >
                          <el-button
                            size="mini"
                            type="info"
                            class="btnBh"
                             style="padding:5px;margin-bottom: 5px;"
                            v-if="has_permission('view:plan_detail')"
                            :disabled="is_post"
                            @click="goToDetail(scope.row.id)"
                            plain
                            >计划单详情</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="采购计划" name="second" v-can="['btn:plan_index_purchase']">
        <el-row v-loading="is_loading">
          <div v-if="dataList.length == 0">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
              "
            >
              <svg-icon style="font-size: 180px" icon-class="no_order" />
              <div style="color: #aaa">暂无计划单</div>
            </div>
          </div>
          <template v-else>
            <el-collapse
              v-model="activeNames"
              @change="handleChange"
              style="position: relative; margin-right: 10px"
            >
              <el-collapse-item
                v-for="(item, index) of purchase"
                :key="item.comID"
                :name="index"
              >
                <template slot="title">
                  <el-checkbox
                    style="margin-left: 10px"
                    @change="headCheckListPurchase(index)"
                    :indeterminate="item.isIndeterminate"
                    :model="item.checkAll"
                  ></el-checkbox>
                  <span
                    style="
                      width: 280px;
                      overflow: hidden;
                      white-space: nowrap;
                      margin-left: 10px;
                      font-size: 15px;
                      font-weight: 500;
                    "
                    >{{ item.name }}</span
                  >
                  <div
                    style="
                       margin-left: 10px;
                       text-align: end;
                       width:110px;
                    "
                  >
                  {{ item.num }}
                  </div>
                  <div
                    style="
                       margin-left: 10px;
                       text-align: end;
                       width:110px;
                    "
                  >
                   {{ item.weight }}
                  </div>
                  <div
                    style="
                      text-align: end;
                       width:110px;
                    "
                  >
                    {{ item.amount }}
                  </div>
                </template>
                <div class="content_table">
                  <el-table
                    v-loading="is_loading"
                    style="width: 100%;"
                    :data="item.orders"
                    :row-style='changebg'
                    :row-class-name="tableRowClassName"
                    :header-cell-style='{background:"#1890ff",color:"#fff"}'
                  >
                    <el-table-column
                      label="序号"
                      type="index"
                      align="center"
                      min-width="3%"
                      width="55"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="goodsName"
                      label="产品"
                      align="center"
                      min-width="7%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planDate"
                      label="计划日期"
                      align="center"
                      min-width="9%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planWeight"
                      align="center"
                      label="计划吨数"
                      min-width="7%"
                    >
                    </el-table-column>
                     <el-table-column
                      prop="letterPrice"
                      label="产品单价"
                      align="center"
                      min-width="7%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planAmount"
                      label="总价"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="plateNumber"
                      label="主车号"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="carriageNumber"
                      label="挂车号"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="driverName"
                      label="驾驶员"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="driverMobile"
                      label="联系电话"
                      align="center"
                      min-width="10%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="planAmount"
                      label="状态"
                      align="center"
                      min-width="6%"
                    >
                      <template slot-scope="scope">
                        <div class="info_text">
                          {{ parseStatus(scope.row.status) }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="remark"
                      label="备注"
                      align="center"
                      min-width="8%"
                    >
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      align="center"
                      min-width="19%"
                    >
                      <template slot-scope="scope">
                        <div class="btn-box">
                          <el-button
                            size="mini"
                            type="info"
                            v-can="['btn:project_approval']"
                            style="padding:5px;margin-bottom: 5px;"
                            @click="exm_ok(scope.row)"
                            v-show="
                              scope.row.arrears == 1 || scope.row.status == 0
                            "
                            >审核</el-button
                          >
                          <el-button
                            size="mini"
                            type="danger"
                            class="btnBh"
                            v-can="['btn:rejection_plan']"
                            style="padding:5px;margin-bottom: 5px;"
                            :disabled="is_post"
                            @click="exm_no(scope.row)"
                            v-show="
                              parseStatus(scope.row.status)=='已打卡'||parseStatus(scope.row.status)=='已登记'
                            "
                            plain
                            >审批驳回</el-button
                          >
                          <el-button
                            size="mini"
                            type="info"
                            class="btnBh"
                             style="padding:5px;margin-bottom: 5px;"
                            v-if="has_permission('view:plan_detail')"
                            :disabled="is_post"
                            @click="goToProcurementDetail(scope.row.id)"
                            plain
                            >计划单详情</el-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-collapse-item>
            </el-collapse>
          </template>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <div class="tabhead" v-show='activeName=="first"'>
      <span>意向计划数&nbsp;{{planNumTotal}}</span>
      <span>可执行计划&nbsp;{{realPlanNumTotal}}</span>
      <span>意向装液量(吨)</span>
      <!-- <span>确认装液量(吨)</span> -->
      <span>应收货款(元)</span>
      <!-- <span>实收货款(元)</span> -->
      <span>账户余额(元)</span>
    </div>
    <div class="tabhead" v-show='activeName=="second"'>
      <span>采购计划数</span>
      <span>计划采购量</span>
      <!-- <span>实际到厂计划数</span> -->
      <!-- <span>实际结算量</span>
      <span>应付货款</span> -->
      <span>实付货款</span>
    </div>
    </div>
    <el-dialog
      :title="is_many ? '批量调价' : '调价'"
      :visible.sync="edit_price_dialog"
      width="25%"
    >
      <el-alert
        show-icon
        title="注意"
        :closable="false"
        description="最终价格 = 实际价格 - 长期优惠 - 销售员优惠"
        type="warning"
        style="margin-bottom: 20px"
      ></el-alert>
      <el-form
        :model="priceForm"
        ref="priceForm"
        :rules="priceRules"
        label-width="120px"
      >
        <el-form-item label="调价价格(元/吨)" prop="realPrice">
          <el-input
            v-model="priceForm.realPrice"
            placeholder="请输入调价价格"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            plain
            type="primary"
            :loading="is_post"
            @click="submitPriceChange"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="模拟称重" :visible.sync="setWeightDialog" width="25%">
      <el-form :model="weightForm" ref="weightForm" label-width="120px">
        <el-form-item label="地磅号">
          <el-input
            type="number"
            placeholder="输入地磅号 1-6"
            v-model="weightForm.weighterNo"
          ></el-input>
        </el-form-item>
        <el-form-item label="重量(kg)">
          <el-input
            type="text"
            placeholder="输入重量 以千克为单位"
            v-model="weightForm.weightValue"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="primary"
            plain
            :loading="is_post"
            @click="setWeightSubmit"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="模拟铅封" :visible.sync="setLeadDialog" width="25%">
      <el-form :model="leadForm" ref="weightForm" label-width="120px">
        <el-form-item label="铅封号">
          <el-input
            type="text"
            placeholder="输入铅封号"
            v-model="leadForm.leadSealNo"
          ></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button
            type="primary"
            plain
            :loading="is_post"
            @click="setLeadSubmit"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导出当前计划 -->
    <el-dialog title="导出计划单" :visible.sync="exportCurrDialog" width="30%">
      <el-form :model="uploadForm" ref="uploadForm" label-width="120px">
        <el-form-item label="计划日期" prop="planDate">
            <el-select v-model="uploadForm.planDate" placeholder="请选择计划日期" style="width:100%">
                <el-option
                    v-for="item in dates"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item style="margin-top:25px;">
          <el-button type="primary" ref="updataButt" plain :icon="uploadBtnIcon" @click="exportCurrSubmit">导出计划单</el-button >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="导入计划单" :visible.sync="uploadDialog" width="30%">
      <el-form :model="uploadForm" ref="uploadForm" label-width="120px">
        <el-form-item label="计划日期" prop="planDate">
            <el-select v-model="uploadForm.planDate" placeholder="请选择计划日期" style="width:100%">
                <el-option
                    v-for="item in dates"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item style="margin-top:25px;">
          <el-button type="primary" ref="updataButt" plain :icon="uploadBtnIcon" @click="clickSubmit">导入计划单</el-button >
          <el-upload
                  multiple
                  ref="upload"
                  v-loading="uploadLoading"
                  :show-file-list="false"
                  accept=".xls,.xlsx"
                  :limit="limitNum"
                  action="baseUrl"
                  :before-upload="beforeAvatarUploadPDF"
                  :http-request="uploadFile"
                  :on-success="fileUploadSuccess"
                  :on-error="fileUploadError"
                  :disabled="fileUploadBtnText == '正在导入'"
                  style="display: inline; margin-left: 10px"
          >
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import defaultSetting from "@/settings";
import { deepClone, parseTime } from "@/utils";
import can from "@/directive/can/index.js";
import { mapGetters } from "vuex";
import { forEach } from "mathjs";
import { getToken } from "@/utils/auth";
export default {
  name: "order_list",
  computed: {
    ...mapGetters(["permissions"]),
  },
  directives: { can },
  data() {
    let validate_cut_price = (rule, value, callback) => {
      if (parseFloat(value) >= parseFloat(this.priceForm.realPrice)) {
        callback(new Error("优惠不能大于价格!"));
      } else {
        callback();
      }
    };
    return {
      value2:"",
      checkList: false, //父级多选
      itemCheck: [], //
      todayPrice: "", //今日销售额
      allCount: "", //今日计划数
      saleAmount: "", //今日销售额
      weight: "", //今日装液量
      currentPlanNum:'',//当前计划
      pendApprovedPlanNum:'',//待审批计划
      approvedPlanNum:'',//已审批计划
      changePlanNum:'',//变更计划
      activeNames: [],
      updataList: [], //模拟条件列表
      discount_list:[],
      is_price: false,
      is_time_price: false,
      is_time_price_add:false,
      activeName: "first",
      activeAudit: false,
      setWeightDialog: false,
      weightForm: {
        orderSn: "",
        weighterNo: "",
        weightValue: "",
      },
      setLeadDialog: false,
      leadForm: {
        orderSn: "",
        leadSealNo: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      tickCount: 0,
      untickCount: 0,
      is_ok: false,
      is_loading: false,
      is_post: false,
      is_select: false,
      is_batch_pass: false,
      is_batch_reject: false,
      data: [],
      dataList: [],
      purchase: [],
      total: 0,
      selectForm: {
        goodsId: "all",
        orderSn: "",
        comId: "",
        planDate: [],
        plateNumber: "",
        driverName: "",
        driverMobile: "",
        carriageNumber: "",
        status: "",
        newStatus:''
      },
      componys: [],
      checked: [],
      edit_dialog: false,
      edit_price_dialog: false,
      priceForm: {
        ids: [],
        realPrice: "",
        saleCutPrice: "",
      },
      priceRules: {
        realPrice: [
          { required: true, message: "请输入实际价格", trigger: "blur" },
          {
            pattern: /^([0-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,
            message: "请输入一个数字,最多保留2位小数",
            trigger: "blur",
          },
        ],
        saleCutPrice: [
          { required: true, message: "请输入销售优惠", trigger: "blur" },
          {
            pattern: /^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,
            message: "请输入一个数字,最多保留2位小数",
            trigger: "blur",
          },
          { validator: validate_cut_price, trigger: "blur" },
        ],
      },
      statuType:[
          {lb:'待审核',vl:0},
          {lb:'已审核',vl:10},
          {lb:'已打卡',vl:15},
          {lb:'已登记',vl:16},
          {lb:'入厂安检',vl:21},
          {lb:'一次过磅',vl:23},
          {lb:'已充装',vl:24},
          {lb:'出厂安检',vl:26},
      ],
      timePriceForm: {
        ids: [],
        realPrice: "",
        saleCutPrice: "",
        time: "",
        product: "",
      },
      timePriceRules: {
        product: [
          { required: true, message: "请选择产品", trigger: "blur" }
        ],
        realPrice: [
          { required: true, message: "请输入实际价格", trigger: "blur" },
          {
            pattern: /^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2})$/,
            message: "请输入一个数字,最多保留2位小数",
            trigger: "blur",
          },
        ],
        saleCutPrice: [
          { required: true, message: "请输入销售优惠", trigger: "blur" },
          {
            pattern: /^([1-9]\d*(\.\d{1,2})?|[0]{1}\.\d{1,2}|0)$/,
            message: "请输入一个数字,最多保留2位小数",
            trigger: "blur",
          },
          { validator: validate_cut_price, trigger: "blur" },
        ],
        time: [
          { required: true, message: "请选择时间", trigger: "blur" }
        ],
      },
      is_many: false,
      goods_list: [],
      active_item: null,
      baseUrl: "",
      fileUploadBtnText: "导入计划单",
      uploadBtnIcon: "el-icon-upload2",
      limitNum: 1,
      multipleSelection: [],
      type_count:0,
      childData:[],
      planNumbers:[],
      uploadDialog:false,
      exportCurrDialog:false,
      dates:[],
      uploadForm: {
        planDate: "",
      },
      uploadLoading:false,
      planNumTotal:0,
      realPlanNumTotal:0
    };
  },
  methods: {
     clickSubmit(){
      if(this.uploadForm.planDate==''){
        this.$message.error("请先选择计划日期！");
      }else{
         this.$refs['upload'].$refs['upload-inner'].handleClick()
      }
    },
    clickUpload(){
      this.uploadDialog=true;

    },
    //导出当前计划
    async exportCurrSubmit(){
      if(this.uploadForm.planDate==''){
        this.$message.error("请先选择计划日期！");
      }else{
          try{
              let res = await fetch(this.baseUrl+"/order/export?planDate="+this.uploadForm.planDate,{
                  method:"GET",
                  headers:{
                      "Authorization":getToken(),
                      "Content-Type":"application/json;charset=utf-8"
                  },
              });
              let blob = await res.blob();
              const a= document.createElement("a")
              a.href = URL.createObjectURL(blob)
              a.download = "计划单"+this.uploadForm.planDate+".xls"
              a.click()
              URL.revokeObjectURL(a.href)
              this.$message.success("导出成功!");
              this.exportCurrDialog = false;
          }catch(err){
          }finally {
          }
      }
    },
    downloadCurrExcel(){
      this.exportCurrDialog = true;
    },
    //已变更计划变色
    changebg({row}) {
      let styleJson={};
      if(row.clientEditFlag==1){// 变颜色的条件
        styleJson={"background-color": "#D1ECCF"}
      }
      return styleJson;
    },
    //当前计划
    currentPlanBtn() {
      this.selectForm.status='';
      if(this.type_count==0){
        this.getData();
      }else if(this.type_count==1){
        this.purchaseList();
      }
    },
    // 待审批计划
    pendApprovedPlanBtn() {
      this.selectForm.status=0;
      if(this.type_count==0){
        this.getData();
      }else if(this.type_count==1){
        this.purchaseList();
      }
    },
    // 已审批计划
    approvedPlanBtn() {
      this.selectForm.status=1;
      if(this.type_count==0){
        this.getData();
      }else if(this.type_count==1){
        this.purchaseList();
      }
    },
    // 变更计划
    changePlanBtn() {
      this.selectForm.status=2;
     if(this.type_count==0){
        this.getData();
      }else if(this.type_count==1){
        this.purchaseList();
      }
    },
    //当前计划4个统计信息
    getCurrCount(){
        request.post('order/curr_count',{type:this.type_count}).then(res=>{
            if(res.code==200){
              this.currentPlanNum=res.data.curr;//当前计划
              this.pendApprovedPlanNum=res.data.noExam;//待审批计划
              this.approvedPlanNum=res.data.examined;//已审批计划
              this.changePlanNum=res.data.modified;//变更计划
            }
        })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // 选择内表格数据-批量审批和批量驳回时使用
      if (this.multipleSelection) {
        this.multipleSelection.forEach((m, v) => {
          m.checkAll = true;
          if (!this.itemCheck.includes(m.id)) {
            this.itemCheck.push(m.id);
          }
        });
      }
      //星星的控制
      // if(this.multipleSelection>=1){
      //   for(let item of this.multipleSelection){
      //     request.post('/order/mark_plan',{orderSn:item.orderSn}).then(res=>{
      //       if(res.code==200){
      //         this.getData();
      //       }
      //     })
      //   }
      // }

    },
    // 隐藏表头中的全选框
    cellClass(row) {
      if (row.columnIndex === 0) {
        return 'disabledCheck'
      }
    },
    //内表格选择计划单
    selectHandle(selection, row){
        if (!this.itemCheck.includes(row.id)) {
          this.itemCheck.push(row.id);
        }else{
          // filter保留符合条件的所有元素。
          this.itemCheck = this.itemCheck.filter(item => item!=row.id)
        }
    },
    clickStar(e){
      request.post('/order/mark_plan',{orderSn:e.orderSn}).then(res=>{
          if(res.code==200){
            this.getData();
          }
        })
    },
    // 下载计划单模板
    async downloadExcel() {
      window.location.href ="https://jbxy-lng-bucket.oss-cn-beijing.aliyuncs.com/excel_template/template.xls"
    },
    beforeAvatarUploadPDF(){
      this.$refs.upload.clearFiles();
    },
    // 导入
    fileUploadSuccess() {
      this.enabledUploadBtn = true;
      this.uploadBtnIcon = "el-icon-upload2";
      this.fileUploadBtnText = "导入计划单";
      this.$message.success("数据导入成功！");
    },
    fileUploadError() {
      this.enabledUploadBtn = true;
      this.uploadBtnIcon = "el-icon-upload2";
      this.fileUploadBtnText = "导入计划单";
    },
    //上传excel文件-请求接口
    uploadFile(item) {
      this.uploadLoading=true;
      let formData = new FormData();
      formData.append("excel", item.file);
      formData.append("planDate",this.uploadForm.planDate);
      request.post("order/import", formData).then((res) => {
        if (res.code == 200) {
          this.getData(true);
          this.uploadLoading=false;
          this.uploadDialog=false;
          this.uploadForm.planDate='';
          this.$message.success("数据导入成功！");
        } else {
          this.uploadLoading=false;
          this.uploadDialog=false;
          this.uploadForm.planDate='';
          this.$message.error("数据导入失败！");
        }
      });
    },
    resetSelect() {
      this.selectForm = {
        goodsId: "all",
        orderSn: "",
        comId: "",
        plateNumber: "",
        driverName: "",
        driverMobile: "",
        carriageNumber: "",
        status: "",
      };
      this.$refs["selectForm"].resetFields();
      this.getData();
    },
    selectSubmit() {
      this.getData();
    },
    //批量调价
    changePrice() {
      if(this.itemCheck.length>0){
        this.is_price = true;
      }else{
        this.$message.error("请选择相对应的计划！");
      }

    },
    //定时调价
    timedPrice() {
      this.is_time_price = true;
      this.getDataList();
    },
    timedPriceAdd() {
      this.is_time_price_add = true;
    },
    //定时调价列表
    getDataList(){
        request.get('order/time/get_price').then(res=>{
            if(res.code==200){
              if(res.data!=null||res.data!=''){
                this.discount_list=res.data
              }

            }
        })
    },
    //删除定时调价
    delAllItem(item,index){
        request.post('order/time/delete_price',{id:item.id}).then(res=>{
            if(res.code==200){
                this.$message.success('删除成功');
                this.getDataList();
            }
        })
    },
    goToAdd() {
      this.$router.push({ name: "plan_add" });
    },
    has_permission(permission) {
      return this.permissions.includes(permission);
    },
    goToDetail(id, type = false) {
      if (!this.has_permission("view:plan_detail")) {
        return false;
      }

      if (type) {
        this.$router.push({
          name: "plan_detail",
          params: { id },
          query: { type: type },
        });
      } else {
        this.$router.push({ name: "plan_detail", params: { id } });
      }
    },
    goToProcurementDetail(id, type = false) {
      if (!this.has_permission("view:financial_detail")) {
        return false;
      }

      if (type) {
        this.$router.push({
          name: "financial_detail",
          params: { id },
          query: { type: type },
        });
      } else {
        this.$router.push({ name: "financial_detail", params: { id } });
      }
    },
    getData(is_init = false) {
      this.planNumbers=[];
      this.planNumTotal=0;
      this.realPlanNumTotal=0;
      if (!is_init) {
        this.is_loading = true;
        this.is_post = true;
      }
      request
        .post("order/com_list", this.selectForm)
        .then((res) => {
          let result = res.data;
          result.forEach((data, index) => {
            data.checkAll = false; //一级是否选中
            data.isIndeterminate = false; //未全选但已经有了选项的状态
            data.planOrders.forEach((m, v) => {
              m.checkAll = false; //二级是否选中
              this.planNumbers.push(m);
            });
            this.planNumTotal+=data.planNum;
            this.realPlanNumTotal+=data.realPlanNum;
          });
          this.dataList = result;
          if (!is_init) {
            this.is_loading = false;
            this.is_post = false;
          } else {
            this.is_ok = true;
          }
        })
        .catch((err) => {
          if (!is_init) {
            this.is_loading = false;
            this.is_post = false;
          } else {
            this.is_ok = true;
          }
        });
    },
    purchaseList() {
      this.planNumbers=[];
      request.post("order/purchase/list", this.selectForm).then((res) => {
        if (res.code == 200) {
          this.purchase = res.data;
          res.data.forEach((data, index) => {
            data.orders.forEach((m, v) => {
              this.planNumbers.push(m);
            });
          });
        }
      });
    },
    //根据关键字查询客户公司
    // selectComMethod(name) {
    //   if (name.length > 1) {
    //     this.is_select = true;
    //     request
    //       .get("company/option?keyword=" + name)
    //       .then((res) => {
    //         if (res.data && res.data.length > 0) {
    //           this.componys = res.data;
    //         } else {
    //           this.componys = [];
    //         }
    //         this.is_select = false;
    //       })
    //       .catch((err) => {
    //         this.is_select = false;
    //       });
    //   }
    // },
    getCompany(){
      request.get("company/option").then(res=>{
          this.componys = res.data;
      }).catch(err=>{
      });
    },
    changeCom(e){
      this.selectForm.comId=e;
      this.getData();
    },
    // parseStatus(num) {
    //   if (num < 5) {
    //     return "待审核";
    //   } else if (num < 10) {
    //     return "销售审核";
    //   } else if (num >= 10 && num < 20) {
    //     switch (num) {
    //       case 15:
    //         return "已打卡";
    //       case 16:
    //         return "已登记";
    //     }
    //     return "已生效";
    //   } else if (num >= 20 && num < 30) {
    //     switch (num) {
    //       case 20:
    //         return "已到场";
    //       case 21:
    //         return "已安检 未入场"; //已到场
    //       case 22:
    //         return "已入场 未过磅"; //已到场
    //       case 23:
    //         return "已过磅 未装液"; //已到场
    //       case 24:
    //         return "装液中"; //已到场
    //       case 25:
    //         return "装液中"; //已到场
    //       case 26:
    //         return "装液中"; //已到场
    //       case 27:
    //         return "已装液"; //已到场
    //     }
    //   }
    // },
    parseStatus(num) {
        switch (num) {
           case 0:
            return "待审核";
          case 10:
            return "已审核"; //待打卡
          case 15:
            return "已打卡"; //待登记
          case 16:
            return "已登记"; //待入场安检
          case 21:
            return "入厂安检"; //待一次过磅
          case 23:
            return "一次过磅";//待充装
          case 24:
            return "已充装"; //待出厂安检
          case 26:
            return "出厂安检"; //待二次过磅
          case 27:
            return "二次过磅"; //待打印
          case 30:
            return "已完成"; //已打印
          case 90:
            return "已取消";
          case 91:
            return "已作废";
          case 92:
            return "已过期";
        }
    },
    parseNums(n,is_int=false) {
        //转化成字符串
        let str = n.toString();
        //若是整数自动补全小数位
        if (-1 == str.indexOf(".")) {
            str = str + ".00"
        }
        if(str.indexOf(".")!=-1){
          let x = str.indexOf('.') + 1;   //小数点的位置
          let y = str.length - x;  //小数的位数
          if(y > 0 && y == 1){
              str = str + "0"
          }
        }
        //全部替换
        if (-1 != str.indexOf(",")) {
            str = str.replace(new RegExp(',', "g"), "")
        }
        let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
        if(is_int){
            return intSum;
        }
        let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
        let ret = intSum + dot;
        return ret;
    },
    statusType(n) {
      if (n < 10) {
        return "warning";
      } else if (n >= 10 && n < 20) {
        return "primary";
      } else if (n >= 20 && n < 30) {
        return "success";
      }
    },
    edit(item) {
      this.active_item = item;
      this.edit_dialog = true;
    },
    editPrice(item) {
      this.active_item = item;
      this.priceForm.realPrice = item.realPrice;
      this.priceForm.saleCutPrice = item.saleCut;
      this.priceForm.ids = [item.id];
      this.is_many = false;
      this.edit_price_dialog = true;
    },
    // 把每一行的索引放进row
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;

      if (this.itemCheck.length !== 0) {

        if (this.itemCheck.includes(row.id)) {
          return "order_item active";
        } else {
          return "order_item";
        }
      }
    },

    //子项点击
    checkItem(item) {
      const index = item.index;
      let chidrenArray = this.dataList[index].planOrders,
        lg = chidrenArray.length;
      if (item.checkAll) {
        this.tickCount++;
        if (this.untickCount > 0) {
          this.untickCount--;
        }
        this.itemCheck.forEach((d, t) => {
          if (item.id == d) {
            this.itemCheck.splice(t, 1);
          }
        });
        item.checkAll = false;
        if (this.tickCount == 0 || this.tickCount != lg) {
          this.dataList[index].checkAll = false;
          this.dataList[index].isIndeterminate = false;
        }
      } else {
        this.untickCount++;
        if (!this.itemCheck.includes(item.id));
        this.itemCheck.push(item.id);
        item.checkAll = true;
      }
      if (this.untickCount == lg) {
        //如果二级全部选中，则一级全部选中
        this.dataList[index].checkAll = true;
        this.dataList[index].isIndeterminate = true;
      } else if (this.untickCount == 0) {
        //二级不选中
        this.dataList[index].checkAll = false;
        this.dataList[index].isIndeterminate = false;
      } else {
        //二级未全选，一级不选中
        this.dataList[index].checkAll = false;
        this.dataList[index].isIndeterminate = false;
      }

      request.post('/order/mark_plan',{orderSn:item.orderSn}).then(res=>{
        if(res.code==200){
           this.getData();
        }
      })

    },
    // checkItem(item, index) {
    //   let chidrenArray = this.dataList[index].planOrders,
    //     lg = chidrenArray.length;
    //   if (item.checkAll) {
    //     this.tickCount++;
    //     if (this.untickCount > 0) {
    //       this.untickCount--;
    //     }
    //     this.itemCheck.forEach((d, t) => {
    //       if (item.id == d) {
    //         this.itemCheck.splice(t, 1);
    //       }
    //     });
    //     item.checkAll = false;
    //     if (this.tickCount == 0 || this.tickCount != lg) {
    //       this.dataList[index].checkAll = false;
    //       this.dataList[index].isIndeterminate = false;
    //     }
    //   } else {
    //     this.untickCount++;
    //     if (!this.itemCheck.includes(item.id));
    //     this.itemCheck.push(item.id);
    //     item.checkAll = true;
    //   }
    //   if (this.untickCount == lg) {
    //     //如果二级全部选中，则一级全部选中
    //     this.dataList[index].checkAll = true;
    //     this.dataList[index].isIndeterminate = true;
    //   } else if (this.untickCount == 0) {
    //     //二级不选中
    //     this.dataList[index].checkAll = false;
    //     this.dataList[index].isIndeterminate = false;
    //   } else {
    //     //二级未全选，一级不选中
    //     this.dataList[index].checkAll = false;
    //     this.dataList[index].isIndeterminate = false;
    //   }
    // },
    //提交价格修改
    submitPriceChange() {
      this.$refs["priceForm"].validate((valid) => {
        if (!valid) return false;
        this.is_post = true;
        request
          .post("order/exe", {
            changeAmount: this.priceForm.realPrice,
            orderIds: this.itemCheck,
          })
          .then((res) => {
            this.$message.success("调价操作成功!");
            this.is_post = false;
            this.is_price = false;
            this.getData();
            this.itemCheck.length=0;
            this.edit_price_dialog = false;
            this.$refs["priceForm"].resetFields();
            this.priceForm = {
              ids: [],
              realPrice: "",
              saleCutPrice: "",
            };
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },

    getGoodsList() {
      request
        .get("goods/dropdown")
        .then((res) => {
          this.goods_list = this.goods_list.concat(res.data);
        })
        .catch((err) => {
        });
    },
    // 定时调价
    submitTimePriceChange() {
      this.$refs["timePriceForm"].validate((valid) => {
        if (!valid) return false;
        this.is_post = true;
        request
          .post("order/time/edit_price", {
            price: this.timePriceForm.realPrice,
            goodsId: this.timePriceForm.product,
            exeTime:this.timePriceForm.time,
          })
          .then((res) => {
            this.$message.success("定时调价操作成功!");
            this.is_post = false;
            this.is_time_price_add=false;
            this.getDataList();
            this.$refs["timePriceForm"].resetFields();
            this.timePriceForm = {
                ids: [],
                realPrice: "",
                saleCutPrice: "",
                time: "",
                product: "",
            };
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },
    setWeight(item) {
      this.active_item = item;
      this.weightForm.orderSn = item.orderSn;
      this.setWeightDialog = true;
    },
    setWeightSubmit() {
      this.is_post = true;
      let url = "order/first_weight";
      if (this.active_item.status == 26) {
        url = "order/second_weight";
      }
      request
        .post(url, this.weightForm)
        .then((res) => {
          this.$message.success("模拟称重提交成功!");
          this.getData();
          this.setWeightDialog = false;
          this.is_post = false;
        })
        .catch((err) => {
          this.is_post = false;
        });
    },
    setLead(item) {
      this.active_item = item;
      this.leadForm.orderSn = item.orderSn;
      this.setLeadDialog = true;
    },
    setLeadSubmit() {
      this.is_post = true;
      request
        .post("order/lead_seal", this.leadForm)
        .then((res) => {
          this.$message.success("模拟铅封完成!");
          this.getData();
          this.setLeadDialog = false;
          this.is_post = false;
        })
        .catch((err) => {
          this.is_post = false;
        });
    },
    //手风琴效果
    handleChange(val) {
      this.activeNames = val;
    },
    //今日模块
    getFourData() {
      request.get("index/plan_count?mode=0").then((res) => {
        if (res.code == 200) {
          this.allCount = res.data.allCount;
        }
      });
      request.get("index/load_weight?mode=0").then((res) => {
        if ((res.code = 200)) {
          this.weight = res.data.weight;
        }
      });
      request.get("index/sale_amount?mode=0").then((res) => {
        if (res.code == 200) {
          this.saleAmount = res.data.saleAmount;
        }
      });
      request.get("index/today_price").then((res) => {
        if (res.code == 200) {
          this.todayPrice = res.data.todayPrice;
        }
      });
    },
    //审核及其shenpi
    exm_ok(item) {
      this.$confirm("此操作将允许该审批单通过, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.is_post = true;
        request
          .post("order/seller/exm", { orderId: item.id, approved: true })
          .then((res) => {
            if (res.code == 200) {
              this.$message.success("操作成功!");
              this.getData();
              this.purchaseList();
              this.is_post = false;
            }
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },
    exm_no(item) {
      this.$prompt("请输入针对该审批单拒绝的理由", "拒绝审批", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /.{0,100}/,
        // inputPattern: /.{1,100}/,
        // inputErrorMessage: "请输入针对该审批单拒绝的理由",
      }).then(({ value }) => {
        this.is_post = true;
        request
          .post("order/seller/exm", { orderId: item.id,approved:false, opinion: value })
          .then((res) => {
            this.getData();
            this.purchaseList();
            this.$message.success("拒绝审批成功!");
            this.is_post = false;
          })
          .catch((err) => {
            this.is_post = false;
          });
      });
    },
    //全选
    headCheckList(i) {
      if (this.dataList[i].checkAll) {
        //一级如果未选中的时候
        this.dataList[i].isIndeterminate = false;
        this.dataList[i].checkAll = false;
        let chidrenArray = this.dataList[i].planOrders;
        let arr = [];
        if (chidrenArray) {
          chidrenArray.forEach((m, v) => {
            m.checkAll = false;
            arr.push(m.id);
          });
          this.itemCheck = this.itemCheck.filter((item) => !arr.includes(item));
        }
      } else {
        //选中的状态
        this.dataList[i].isIndeterminate = true;
        this.dataList[i].checkAll = true;
        let chidrenArray = this.dataList[i].planOrders;
        if (chidrenArray) {
          chidrenArray.forEach((m, v) => {
            m.checkAll = true;
            if (!this.itemCheck.includes(m.id)) {
              this.itemCheck.push(m.id);
            }
          });
        }
      }
    },
    headCheckListPurchase(i) {
      if (this.purchase[i].checkAll) {
        //一级如果未选中的时候
        this.purchase[i].isIndeterminate = false;
        this.purchase[i].checkAll = false;
        let chidrenArray = this.purchase[i].orders;
        let arr = [];
        if (chidrenArray) {
          chidrenArray.forEach((m, v) => {
            m.checkAll = false;
            arr.push(m.id);
          });
          this.itemCheck = this.itemCheck.filter((item) => !arr.includes(item));
        }
      } else {
        //选中的状态
        this.purchase[i].isIndeterminate = true;
        this.purchase[i].checkAll = true;
        let chidrenArray = this.purchase[i].orders;
        if (chidrenArray) {
          chidrenArray.forEach((m, v) => {
            m.checkAll = true;
            if (!this.itemCheck.includes(m.id)) {
              this.itemCheck.push(m.id);
            }
          });
        }
      }
    },
    //tabs切换
    handleClick(tab, event) {
      this.activeNames = false;
      if(tab.name=='first'){
          this.type_count=0;
          this.getData();
      }else{
          this.type_count=1;
          this.purchaseList();
      }
      this.getCurrCount();
    },
    //销售审核开关
    switch_exm(e) {
      this.activeAudit = e;
      request.post("/web_config/switch_exm", { switchExm: e }).then((res) => {
        //哈哈，朕也不知道是干嘛！！！！
      });
    },

    auditSwitch() {
      request.post("web_config/get/SELLER_EXM").then((res) => {
        if (res.code == 200) {
          if (res.data.value == "NOT_EXAMINE") {
            this.activeAudit = false;
          } else {
            this.activeAudit = true;
          }
        }
      });
    },
    // 批量审批
    batchApproval() {

      if(this.itemCheck.length==0){
        this.$message.error("请选择相对应的计划！");
      }else{
        this.is_batch_pass = true;
        request.post("order/seller/batch_exm",{approved: true,opinion: "",orderIds: this.itemCheck}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.is_batch_pass = false;
            this.getData(true);
            this.purchaseList();
            this.itemCheck=[];
          }else{
            this.$message.error(res.msg);
          }
        });
      }
    },
    // 批量驳回
    batchRejected() {
      if(this.itemCheck.length==0){
        this.$message.error("请选择相对应的计划！");
      }else{
          this.is_batch_reject = true;
        request.post("order/seller/batch_exm",{approved: false,opinion: "",orderIds: this.itemCheck}).then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.is_batch_reject = false;
            this.getData(true);
            this.purchaseList();
            this.itemCheck=[];
          }else{
            this.$message.error(res.msg);
          }
        });
      }
    },
  },
  created() {
    this.getGoodsList();
    let time = new Date();
    this.dates.push(parseTime(time,"{y}-{m}-{d}"));
    time = time.getTime()+86400000;
    this.dates.push(parseTime(time,"{y}-{m}-{d}"));
  },
  mounted() {
    this.auditSwitch();
    this.getData(true);
    // this.getFourData();
    // this.purchaseList();
    this.getCurrCount();
    this.baseUrl =
      process.env.VUE_APP_BASE_API + "/" + defaultSetting.api_version;
    this.getCompany();
  },
};
</script>

<style lang="scss">
.el-form-item {
    margin-bottom:5px;
}
.tabs{
   position:relative;
}
.tabhead{
  position:absolute;
  top:10px;
  left:345px;
  z-index:999;
}
.tabhead span{
  font-size:13px;
  margin-left:50px;
}
.commonBtn {
  position: absolute;
  right: 175px;
  top: 190px;
}
.order_item {
  margin-bottom: 20px;
  margin-right: 10px;

  &.active {
    background: rgb(217, 236, 255);
  }

  .item_body {
    min-height: 110px;
    padding: 20px;
    position: relative;

    .item_header {
      height: 20px;
      display: flex;
      align-items: center;
      line-height: 20px;
      width: 100%;

      .btns {
        display: flex;
        position: absolute;
        right: 0px;

        .item_btn {
          margin-left: 10px;
          transition: all 0.5s;
          cursor: pointer;
          color: #67c23a;
          background: transparent;
          &:hover {
            color: #fff;
            background: #67c23a;
            font-size: 1.1em;
          }
        }
      }
    }

    .item_item {
      display: inline-block;
      margin-right: 30px;
      line-height: 30px;
      &.ptext {
        font-size: 16px;
      }
    }
  }

  .item_footer {
    height: 39px;
    border-top: 1px solid #ddd;
    line-height: 39px;
    font-size: 14px;
    padding: 0 20px;
  }

  .ptext {
    color: #666666;
    font-size: 14px;
  }
}
.btn-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.iconSize{
  font-size:24px;
}
.type_class{
  background-color: #bfe7bc;
}

.disabledCheck .cell .el-checkbox__inner{
    display: none!important;
  }
.disabledCheck .cell:before{
    content: '';
    position: absolute;
    right: 11px;
}
</style>


